// extracted by mini-css-extract-plugin
export default {"semibold":"EmailDeleteModal_semibold__xQd5v"};